import { Routes } from '#Routes';

export const serverError = (api) => (next) => (action) => {
  if (action.payload?.originalStatus === 500) {
    window.location = Routes.ServerError.path;
  }

  return next(action);
};
